//@flow
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { AudioSource, SourceType } from "../audioplayer-v2/source";
import Heading from "../heading";
import SocialIcons from "../social-icons/social-icons";
// import Circles from "../circles";
// $FlowFixMe
import css from "./stations.module.scss";
// import Store from "../../services/store";
import openExternalLink from "../../lib/externallink";
import { faPlayCircle, faPauseCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { Actions } from "../../services/actions";

const adjustColour = (color, amount) => {
  return "#" + color.replace(/^#/, "").replace(/../g, (color) => ("0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
};

const handlePlay = (station: Object, e: Object, isCurrentMedia: boolean) => {
  if (isCurrentMedia) {
    Actions.togglePlay();
  } else {
    const src = new AudioSource();
    src.src = station.hlsURL;
    // src.title = station.name;
    // src.description = station.shortDescription;
    src.srctype = SourceType.HLS;
    // src.img = station.headerImage;
    src.isLiveStream = true;
    src.id = station.stationID;
    // PlayerActions.playSource(src);
    Actions.setCurrentSrc(src);
    Actions.setDesiredPlayState(true);
  }
};

const Station = (props: Object): Object => {
  const { isCurrentMedia, playState, station } = props;
  // console.log(station?.nowFeature?.sponsor)
  let icon = faPlayCircle;
  let spin = false;
  if (isCurrentMedia && playState === "PLAYING") icon = faPauseCircle;
  if (isCurrentMedia && playState === "BUFFERING") {
    icon = faSyncAlt;
    spin = true;
  }
  // const img = station.now?.show?.image || station.headerImage;
  const img = station.logoHz;
  const sponsorImage = station.nowFeature?.sponsor?.image;
  const artistImage = station.nowSong?.artists[0]?.image;

  let showName = station.name;
  let showDesc = station.shortDescription;

  if (station.nowFeature?.name && station.nowFeature?.name !== "In Demand Radio") {
    showName = station?.nowFeature?.name;
    showDesc =  station.nowFeature.description;
  }
  return (
    <div className={css.station} >
      <div className={css.stationImageWrapper}>
        <img className={css.stationImg} src={img} alt={`${station.name} logo`} />
      </div>
      <Heading colour={station?.colour} title="Live Now"></Heading>

      <div className={css.onAir} onClick={(e) => handlePlay(station, e, isCurrentMedia)}>
        <img className={css.showImage} src={station.nowFeature?.image || station.logoSq} alt="Station" />
        <div className={css.info}>
          <div className={css.name}>
            <span className={css.playbutton} >
              <FontAwesomeIcon icon={icon} spin={spin} />
            </span>
            {showName}
          </div>
          <div className={css.showDesc}>{showDesc}</div>
          {station.nowFeature?.displayNowPlaying !== false && station.nowSong?.title ? (
            <div className={css.now}>
              <div className={css.nowText} style={{ backgroundColor: adjustColour(station.colour, 80) }}>
                <span>
                  Now Playing
                  <br />
                  <b>{station.nowSong?.title}</b>
                  <br />
                  by <b>{station.nowSong?.artistDisplay}</b>
                </span>
              </div>
              {artistImage ? <img src={artistImage} alt={station?.nowFeature?.name}></img> : null}
            </div>
          ) : null}
        </div>
      </div>

      <div className={css.sponsorTag}>
        {sponsorImage ? (
          <div className={css.sponsorTagImage}>
            <img
              alt={station.nowFeature?.sponsor?.name}
              src={sponsorImage}
              onClick={(e) => {
                if (station.nowFeature?.sponsor?.url) {
                  openExternalLink(station.nowFeature?.sponsor?.url);
                }
              }}
            ></img>
          </div>
        ) : null}
        {station?.nowFeature?.sponsor?.name ? (
          <div className={css.sponsorTagInfo}>
            <div className={css.sponsorTagAssoc}>IN ASSOCIATION WITH</div>
            <div className={css.sponsorTagName}>{station?.nowFeature?.sponsor?.name}</div>
            <div className={css.sponsorTagText}>{station?.nowFeature?.sponsor?.text}</div>
          </div>
        ) : null}
      </div>

      <SocialIcons />
      {/* <Explore /> */}
      {/* {station.stationID === "IDR1" ? <TextNumber /> : null} */}
    </div>
  );
};
export default Station;

// const TextNumber = () => {
//   return (
//     <div className={css.sms}>
//       <div className={css.small}>Text the studio</div>
//       <b>RADIO</b> + your message to <b>81066</b>
//     </div>
//   );
// };
// const Explore = () => {
//   return (
//     <div className={css.explore}>
//       <a href="https://idrad.io" target="_blank" rel="noopener noreferrer">
//         <div>
//           <span className={css.explore}>EXPLORE MORE</span>
//           &nbsp;
//           <span className={css.idr}>In Demand Radio</span>
//         </div>
//         <div className={css.icon}>
//           <FontAwesomeIcon icon={faArrowCircleRight} />
//         </div>
//       </a>
//     </div>
//   );
// };

/*
        <div className={css.playbutton} style={{ backgroundColor: station.colour }}>
          <FontAwesomeIcon icon={icon} spin={spin} />
        </div>
        {sponsorImage ? (
          <div className={css.sponsor}>
            <img
              alt="sponsor"
              src={sponsorImage}
              onClick={(e) => {
                if (station.nowFeature?.sponsor?.url) {
                  openExternalLink(station.nowFeature?.sponsor?.url);
                }
              }}
            ></img>
          </div>
        ) : null}



        <div className={css.name} style={{ backgroundColor: station.colour }}>
          NOW: {station.now?.show?.name}
        </div>


                  {station.shortDescription ? <div className={css.desc}>{station.shortDescription}</div> : null}

        */
